import { Text, View } from '@react-pdf/renderer';
import { type PropsWithChildren, type ReactElement } from 'react';
import { PDF_STYLES } from '../../styles';

export const SectionBox = ({
  title,
  children,
}: PropsWithChildren<{ title: string }>): ReactElement => (
  <View style={PDF_STYLES.section}>
    <Text style={PDF_STYLES.sectionTitle}>{title}</Text>
    <View style={PDF_STYLES.sectionContent}>{children}</View>
  </View>
);
